//Views
PJQ.views.profile = {};

PJQ.views.profile.CompanyProfile = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROFILE, 'Company-Profile')
	},
	events: {
		'click .profile-edit': 'edit',
		'click .profile-view-qualification': 'viewScreenings',
		'click .profile-add-logo': 'addLogo',
		'click .profile-nav-item': 'tabActivated',
		'click .profile-project-reference-photo': 'viewReferencePhotoClick',
		'click .profile-project-reference-photo-delete': 'deleteReferencePhoto',
		'click .profile-company-photo': 'viewCompanyPhotoClick',
		'click .profile-company-photo-delete': 'deleteCompanyPhoto',
		'click .profile-cancel-edit': 'cancelEdit',
		'click .profile-theme-restore-defaults': 'restoreDefaultTheme',
		'click .profile-save': 'save'
	},
	beforeFirstRender: function () {
		if (this.model == null) {
			if (_.size(this.options.key) > 0) {
				this.model = new PJQ.models.profile.CompanyProfile({
					profileKey: this.options.key
				});
			}
			else {
				this.model = new PJQ.models.profile.CompanyProfile();
			}
		}

		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	beforeRender: function () {
		this.mapId = 'rmap_' + _.uniqueId();
		this.groupLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) : "Trades";
		this.maxGroups = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.RESTRICT_GROUP_COUNT) : 10;
		this.renderData = {
			model: this.model,
			isEdit: this.isEdit,
			canEdit: this.model.get('canEdit'),
			mapId: this.mapId,
			groupLabel: this.groupLabel,
			maxGroups: this.maxGroups
		};
		this.activateTabId = this.$('.tab-pane.active').attr('id');
	},
	afterRender: function () {
		if (!this.model.isFetched) {
			this.loader = new PJQ.Loader(this.$el);
		}
		else {
			if (this.loader) {
				this.loader.remove();
				this.loader = null;
			}

			if (_.size(this.options.activateTab) > 0) {
				this.activateTab(this.options.activateTab);
				this.options.activateTab = null;
			}
			else if (_.size(this.activateTabId) > 0) {
				this.$('.nav-link[href="#' + this.activateTabId + '"]').tab('show');
				this.activateTabId = null;
			}

			this.renderLogo();
			this.renderTheme();
			this.renderOfficeLocationMap();
			this.renderWorkAreaMap();
			if (this.isEdit) {
				this.renderThemeEditor();
				this.renderGroupSelector();
				this.renderToolbar();
				this.renderProjectReferencePhotoUploaders();
				this.renderCompanyPhotoUploader();
				new PJQ.Binder(this.$el, this.model, {
					watchElements: [
						'input',
						'textarea'
					]
				});
			}

			if (this.options.projectReferenceId > 0 && this.options.projectReferencePhotoId > 0) {
				let reference = this.model.projectReferences.get(this.options.projectReferenceId);
				if (reference != null) {
					let photo = reference.photos.get(this.options.projectReferencePhotoId);
					if (photo != null) {
						this.viewReferencePhoto(reference, photo);
						this.$('.nav-link[href="#profileProjects"]').tab('show');
					}
				}
				this.options.projectReferenceId = null;
				this.options.projectReferencePhotoId = null;
			}
		}
	},
	activateTab: function (tab) {
		switch (tab ? tab.toLowerCase() : null) {
			case 'workareas':
				tab = 'profileWorkAreas';
				break;
			case 'projectreferences':
				tab = 'profileProjects';
				break;
			case 'photos':
				tab = 'profilePhotoGallery';
				break;
			default:
				tab = 'profileCompanyInfo';
				break;
		}
		this.$('.nav-link[href="#' + tab + '"]').tab('show');
	},
	tabActivated: function (e) {
		let newTabId = $(e.target).attr('href').replace('#', ''),
			route;
		switch (newTabId.toLowerCase()) {
			case 'profileworkareas':
				this.workAreaMap.refresh();
				this.refreshWindow();
				route = 'workareas';
				break;
			case 'profileprojects':
				route = 'projectreferences';
				break;
			case 'profilephotogallery':
				route = 'photos';
				break;
		}
		PJQ.app.router.navigate(PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'profiles',
				value: this.model.id
			},
			{
				endpoint: route
			}
		]));
	},
	renderLogo: function (base64) {
		if(_.size(base64) > 0 || _.size(this.model.get('logoURL')) > 0){
			let $logo = $('<img>', {
				class: 'max-wd-100p max-ht-100p'
			});
			$logo.on('load', function () {
				$logo.css('margin-top', ((120 - $logo.height()) / 2).toString() + 'px');
			});
			if (_.size(base64) > 0) {
				$logo.attr('src', base64);
			} else {
				$logo.attr('src', PJQ.helpers.urlHelpers.buildAPIURL(this.model.get('logoURL'), false, false, true));
			}
			this.$('.profile-logo-container').html($logo);
		}
	},
	refreshWindow: function() {
		setTimeout(function(){ window.dispatchEvent(new Event('resize')); }, 50);
	},
	renderThemeEditor: function () {
		let theme = this.model.get('theme');
		new PJQ.colors.ColorPicker(this.$('.profile-theme-header'), {
			format: 'hex',
			color: theme.headerBackgroundColor,
			onChange: _.bind(function (value) {
				theme.headerBackgroundColor = value;
				this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});

		new PJQ.colors.ColorPicker(this.$('.profile-theme-nav-items'), {
			format: 'hex',
			color: theme.navMenuTextColor,
			onChange: _.bind(function (value) {
				theme.navMenuTextColor = value;
                this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});

		new PJQ.colors.ColorPicker(this.$('.profile-theme-section-header'), {
			format: 'hex',
			color: theme.sectionHeaderTextColor,
			onChange: _.bind(function (value) {
				theme.sectionHeaderTextColor = value;
                this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});

		new PJQ.colors.ColorPicker(this.$('.profile-theme-section-body'), {
			format: 'hex',
			color: theme.sectionBodyTextColor,
			onChange: _.bind(function (value) {
				theme.sectionBodyTextColor = value;
                this.toolbar.autoShowToolbar();
				this.renderTheme();
			}, this)
		});
	},
	renderGroupSelector: function () {
		this.groupSelector = new PJQ.views.groups.GroupSelector({
			el: this.$('.profile-group-selector'),
            onSelect: _.bind(function(){
                this.toolbar.renderChangedCount();
            },this),
			selectedGroupIds: this.model.groups.getGroupIds(),
			isPublicGroups: true,
			isEnableSelectAll: false,
			maxGroups: this.maxGroups,
            isDisableParents: true
		});
	},
	renderOfficeLocationMap: function () {
		let officeLocationMap = new PJQ.maps.GoogleMap(this.$('.office-location-map-container'));
		_.each(this.model.get('offices'), function (office) {
			officeLocationMap.addMarker(office.latitude, office.longitude, {
				title: office.city + ', ' + office.state + ' ' + office.zip,
				infoWindowContent: office.city + ', ' + office.state + ' ' + office.zip
			});
		});
	},
	renderWorkAreaMap: function () {
		this.workAreaMap = new PJQ.views.workAreas.WorkAreaMap({
			el: this.$('.profile-work-areas'),
			contactId: this.model.get('primaryContactId'),
			isEdit: this.isEdit,
			isMapOnly: !this.isEdit,
			isInline: !this.isEdit,
			onDelete: _.bind(function(){
				this.toolbar.autoShowToolbar()
			},this),
			isSync: false,
			onFetch: _.bind(function () {
				if (_.size(this.workAreaMap.collection.models) > 0) {
					this.$('.profile-work-areas-nav-item').removeClass('hidden');
				}
				else if (this.model.get('canEdit') && !this.isEdit) {
					new PJQ.Alert(this.$('.profile-work-areas'), {
						type: 'primary',
						text: 'Click <strong><a href="javascript:void(0)" class="profile-edit">edit</a></strong> to add work areas. This section will currently be hidden to anybody viewing your profile.',
						isPrepend: true
					});
				}
			}, this)
		});
	},
	fetchModel: function() {
		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	renderToolbar: function() {
		this.toolbar = new PJQ.views.toolbars.ProfileSaveToolbar({
			model: this.model,
			el: this.$el,
			groupSelector: this.groupSelector,
			isEdit: this.isEdit,
			workAreaMap: this.workAreaMap.collection,
			onSave: _.bind(function () {
				this.save()
			}, this),
			onClose: _.bind(function () {
				this.fetchModel()
			}, this)
		})
	},
	renderTheme: function () {
		let theme = this.model.get('theme');
		this.$('.profile-main-header').css('background', theme.headerBackgroundColor);
		this.$('.profile-nav-item').css('cssText', 'color:' + theme.navMenuTextColor + ' !important');
		this.$('.profile-section-header').css('color', theme.sectionHeaderTextColor);
		this.$('.profile-section-body').css('color', theme.sectionBodyTextColor);

		let idealTextColor = PJQ.helpers.colorHelpers.idealLinkColorForBackground(theme.headerBackgroundColor),
			cancelEditButton = this.$('.profile-cancel-edit');
		if (_.size(cancelEditButton) > 0) {

			if (idealTextColor === '#fff') {
				cancelEditButton.removeClass('btn-secondary').addClass('btn-transparent-light');
			}
			else {
				cancelEditButton.removeClass('btn-transparent-light').addClass('btn-secondary');
			}
		}
		this.$('.profile-header-company-details').css('color', idealTextColor);
	},
	renderProjectReferencePhotoUploaders: function () {
		if (this.isEdit) {
			_.each(this.model.projectReferences.models, _.bind(function (projectReference) {
				let uploader = new PJQ.views.files.FileUploader({
					el: this.$('.profile-project-reference[data-cid="' + projectReference.cid + '"]').find('.profile-project-reference-photo-upload'),
					allowedExtensions: PJQ.constants.files.imageExtensions,
					onSuccess: _.bind(function () {
						projectReference.set('uploadFolderId', uploader.options.uuid);
						this.$('.profile-project-reference[data-cid="' + projectReference.cid + '"]').find('.alert').remove();
                        this.toolbar.autoShowToolbar();
					}, this)
				});
			}, this));
		}
	},
	viewReferencePhotoClick: function (e) {
		let referenceCid = $(e.currentTarget).closest('.profile-project-reference').data('cid'),
			reference = this.model.projectReferences.get(referenceCid),
			photo = reference.photos.get($(e.currentTarget).data('cid'));
		this.viewReferencePhoto(reference, photo);
	},
	viewReferencePhoto: function (reference, photo) {
		PJQ.app.view.renderPhotoViewer({
			image: photo.get('url')
		});
	},
	deleteReferencePhoto: function (e) {
		let deleteButton = $(e.currentTarget),
			photoContainer = deleteButton.parent('div'),
			referenceCid = deleteButton.closest('.profile-project-reference').data('cid'),
			reference = this.model.projectReferences.get(referenceCid),
			photo = reference.photos.get(deleteButton.siblings('.profile-project-reference-photo').data('cid'));

		this.deletedReferencePhotos.push(photo);
		photoContainer.animateCSS('fadeOut', function () {
			photoContainer.remove();
            this.toolbar.autoShowToolbar();
		});
	},
	viewCompanyPhotoClick: function (e) {
		this.viewCompanyPhoto(this.model.companyPhotos.get($(e.currentTarget).data('cid')));
	},
	viewCompanyPhoto: function (photo) {
		PJQ.app.view.renderPhotoViewer({
			image: photo.get('url')
		});
	},
	deleteCompanyPhoto: function (e) {
		let deleteButton = $(e.currentTarget),
			photoContainer = deleteButton.parent('div'),
			photo = this.model.companyPhotos.get(deleteButton.siblings('.profile-company-photo').data('cid'));

		this.deletedCompanyPhotos.push(photo);
		photoContainer.animateCSS('fadeOut', function () {
			photoContainer.remove();
		});
		this.toolbar.autoShowToolbar();
	},
	renderCompanyPhotoUploader: function () {
		if (this.isEdit) {
			let uploader = new PJQ.views.files.FileUploader({
				el: this.$('.profile-company-photo-upload'),
				allowedExtensions: PJQ.constants.files.imageExtensions,
				onSuccess: _.bind(function () {
					this.model.set('companyPhotoUploadFolderId', uploader.options.uuid);
					this.$('.profile-company-photo-alert').remove();
                    this.toolbar.autoShowToolbar();
				}, this)
			});
		}
	},
	addLogo: function () {
		let fileUploaderModal = new PJQ.views.files.FileUploaderModal({
			header: 'Upload Logo',
			isShowOkButton: false,
			maxFiles: 1,
			allowedExtensions: PJQ.constants.files.imageExtensions,
			onDone: _.bind(function (files) {
				if(_.size(files) > 0){
					let file = files[0];
					this.model.set('logoUploadFolderId', file.get('folder'));
					this.renderLogo(file.dataUrl);
					fileUploaderModal.removeModal();
					this.toolbar.autoShowToolbar();
				}
			}, this)
		});
	},
	restoreDefaultTheme: function () {
		this.model.restoreDefaultTheme();
		this.render();
	},
	viewScreenings: function () {
		PJQ.app.router.navigate('screenings', {
			trigger: true
		});
	},
	cancelEdit: function () {
		this.isEdit = false;
		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		})
	},
	edit: function () {
		this.isEdit = true;
		this.deletedReferencePhotos = [];
		this.deletedCompanyPhotos = [];
		this.render();
	},
	save: function () {
		this.groupSelector.hideError();
		if(this.groupSelector.getGroupsData().selected.length > this.groupSelector.maxGroups){
			this.groupSelector.showError("You may only select " + this.groupSelector.maxGroups + " " + this.groupLabel + "!");
			return
		}
		this.isEdit = false;
		this.$('.profile-cancel-edit').prop('disabled', true);
		this.$('.profile-save').prop('disabled', true).text('Saving...');

		if (_.size(this.deletedReferencePhotos) > 0) {
			_.each(this.deletedReferencePhotos, function (photo) {
				let projectReference = this.model.projectReferences.get(photo.get('projectReferenceId'));
				projectReference.photos.remove(photo);
				projectReference.set('photos', projectReference.photos.toJSON());
				photo.destroy();
			}, this);
			this.deletedReferencePhotos = [];
		}

		if (_.size(this.deletedCompanyPhotos) > 0) {
			_.each(this.deletedCompanyPhotos, function (photo) {
				photo.destroy();
			});
			this.model.companyPhotos.remove(this.deletedCompanyPhotos);
			this.deletedCompanyPhotos = [];
		}

		this.workAreaMap.save(_.bind(function () {
			this.model.groups = new PJQ.collections.groups.Groups(this.groupSelector.getGroupsData().selected, {
				masterUserId: this.model.groups.options.masterUserId
			});
			this.model.save({
				groups: this.model.groups.toJSON()
			}, {
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}, this));
	}
});
